import { BaseDto } from '@greco/util-dto';
import { Type } from 'class-transformer';
import { IsNumber, IsOptional, IsString } from 'class-validator';
import { TilesGroupDto } from './tile-group.dto';

export class UpdateTileDto extends BaseDto {
  @IsString()
  @IsOptional()
  communityId!: string;

  @IsString()
  @IsOptional()
  label?: string;

  @IsString()
  @IsOptional()
  imageUrl?: string;

  @IsString()
  @IsOptional()
  url?: string;

  // @IsBoolean()
  status!: boolean;

  @Type(() => TilesGroupDto)
  @IsOptional()
  tileGroup?: TilesGroupDto;

  @IsString()
  @IsOptional()
  tileGroupId?: string | null;

  @IsNumber()
  @IsOptional()
  priority?: number;
}
